import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import gift from "../../assets/images/icon/gift-white.svg";
import right from "../../assets/images/icon/right-blue.svg";
import left from "../../assets/images/icon/left-blue.svg";
import all from "../../assets/images/my-point/all-blue.png";
import allGreen from "../../assets/images/my-point/all.png";
const maxStamp = 6;
const defBookStamp = {
  clinicPetShop: "0",
  clinicPetShopName: "...",
  bookNo: 0,
  totalStamp: 0,
  species: null
};

export default function StampCardMain({
  stampCountList = [],
  reward = {},
  onNext = () => console.log("onNext!"),
  onBack = () => console.log("onBack!"),
}) {
  const navigate = useNavigate();

  const tmpStampCountList = JSON.parse(JSON.stringify(stampCountList));

  let _stampCountList = [];
  const arrTotalStampAll = tmpStampCountList.map((item) => item.totalStamp);
  const totalStampAll = arrTotalStampAll.reduce(
    (acc, cur) => Number(acc) + Number(cur),
    0
  ); // sum

  // คำนวณเล่มที่ตามเงื่อนไข
  const calculateBookNumber = () => {
    // ถ้ามี _stampCountList[0].bookNo อยู่แล้ว ใช้อันนี้
    if (_stampCountList[0] && _stampCountList[0].bookNo) {
      return _stampCountList[0].bookNo;
    }

    const catCount = reward.cat || 0;
    const dogCount = reward.dog || 0;

    if (catCount === 0 && dogCount === 0) {
      return 1;
    } else if ((catCount === 3 && dogCount === 0) || (dogCount === 3 && catCount === 0)) {
      return 3;
    } else if (catCount === 3 && dogCount === 3) {
      return 6;
    } else {
      return catCount + dogCount + 1;
    }
  };

  if (totalStampAll % 6 === 0 || tmpStampCountList.length === 0) {
    _stampCountList = tmpStampCountList;
    const bookNoNew = tmpStampCountList
      .map((item) => item.bookNo)
      .sort(function (a, b) {
        return b - a;
      });
    console.log("bookNoNew >>", bookNoNew);
    _stampCountList.unshift({ ...defBookStamp, bookNo: bookNoNew[0] + 1 });
  } else {
    _stampCountList = tmpStampCountList;
  }
  if (reward.dog == 3 && reward.cat == 3) {
    tmpStampCountList[0].totalStamp = 6;
  } else if (reward.dog == 3 && !_stampCountList[0].species ) {
    tmpStampCountList[0].totalStamp = 6;
  }
  _stampCountList = tmpStampCountList;
  console.log("_stampCountList >>", _stampCountList);
  console.log("reward >>", reward);

  // คำนวณเล่มที่หลังจากสร้าง _stampCountList แล้ว
  const currentBookNumber = calculateBookNumber();

  // Helper functions สำหรับเงื่อนไข
  const isDogCompleted = () => {  
    console.log("reward.latestSpecies >>", reward.latestSpecies);
    return (reward.dog == 3 && reward.cat === 0 ) || (reward.dog == 3 && reward.cat < 3 && !_stampCountList[0]?.species) || (reward.dog == 3 && reward.cat == 3 && reward.latestSpecies == 1);
  };

  const isCatCompleted = () => {
    console.log("reward.latestSpecies >>", reward.latestSpecies);
    return (reward.cat == 3 && reward.dog === 0) || (reward.dog < 3 && reward.cat == 3 && !_stampCountList[0]?.species) || (reward.dog == 3 && reward.cat == 3 && reward.latestSpecies == 2);
  };

  // Helper function สำหรับแสดงชื่อสาขา
  const getBranchName = () => {
    if (stampCountList.length > 0) {
      return _stampCountList[0].clinicPetShopName;
    }

    if (reward.dog === 3 && reward.cat === 3) {
      return reward.latestSpecies === 1
        ? reward.dogHistory[2].name
        : reward.catHistory[2].name;
    }

    if (reward.dog === 3 && reward.cat === 0) {
      return reward.dogHistory[2].name;
    }

    if (reward.cat === 3 && reward.dog === 0) {
      return reward.catHistory[2].name;
    }

    return null;
  };

  return (
    <div className="pStampMain">
      <div className="bStampCard">
        <div className="bStampHead">
          {/* {totalStampAll} */}
          <div className="bLeft">
            <h3>สมุดสะสม Stamp ของฉัน</h3>
            {getBranchName() && (
              <p>
                <span>{" สาขา" + getBranchName()}</span>
              </p>
            )}
          </div>

          <div className="bRight">
            <button
              className={`btn h-[38px] ${currentBookNumber <= 1 ? 'bg-[#8F8F8F]' : ''}`}
              style={currentBookNumber <= 1 ? {
                backgroundColor: '#8F8F8F !important',
                color: 'white !important',
                border: '1px solid #8F8F8F !important',
                cursor: 'none'
              } : {}}
              onClick={() => {
                if (currentBookNumber > 1) {
                  navigate("/redeem-gift-member");
                }
              }}
            >
              <img src={gift} alt="gift" className="w-[20px] h-[20px] mr-[5px]" />
              ดูของรางวัล
            </button>
          </div>

        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'end' }}>
          <p className="text-[24px] font-bold text-blue">
            เล่มที่ {currentBookNumber}
          </p>
          <p className="text-[18px] text-blue">
            แสตมป์ที่ได้รับแล้ว: {_stampCountList[0]?.totalStamp || 0}/{maxStamp}
          </p>
        </div>

        {(() => {
          // เงื่อนไขสำหรับแสดงธีมสีฟ้า (dog card) ตามลำดับความสำคัญ
          // 1. เงื่อนไขใหญ่สุด: dog 3 cat 3 ไม่มี species แสดงตาม latestSpecies 1=ฟ้า 2=เขียว
          const condition1 = (reward.dog == 3 && reward.cat == 3 && !_stampCountList[0]?.species && reward.latestSpecies == 1);
          
          // 2. dog = 3 cat < 3 ไม่มี species แสดงสีฟ้า
          const condition2 = (reward.dog == 3 && reward.cat < 3 && !_stampCountList[0]?.species);
          
          // 3. dog <= 3 cat < 3 ไม่มี species แสดงสีฟ้า
          const condition3 = (reward.dog < 3 && reward.cat <= 3 && !_stampCountList[0]?.species);
          
          // 4. dog=0 cat=0 ไม่มี species แสดงสีฟ้า
          const condition4 = (reward.dog === 0 && reward.cat === 0 && !_stampCountList[0]?.species);
          
          // 5. ถ้ามี species แสดงตาม species (species = 1 = ฟ้า)
          const condition5 = (_stampCountList[0]?.species == 1);
          
          const showDogCard = condition1 || condition2 || condition3 || condition4 || condition5;
          
          return showDogCard;
        })() ? (
          <div className="bPackCard" style={{
            position: 'relative',
            backgroundColor: isDogCompleted() ? '#F8F9FA' : '',
            opacity: isDogCompleted() ? 0.7 : 1
          }}>
            {[...Array(6)].map((item, i) => {
              return (
                <div
                  className={`bItemCard ${(_stampCountList[0]?.totalStamp || 0) > i ? " done " : ""
                    }`}
                >
                  {(_stampCountList[0]?.totalStamp || 0) > i ? (
                    <>
                      <i>{i + 1}</i>
                      <img
                        className="bPic done"
                        src={`assets/img/ci/my-point-stamp/used/stamp-p2-${i + 1}.png`}
                      ></img>
                    </>
                  ) : (
                    <>
                      <i>{i + 1}</i>
                      <img
                        className="bPic free"
                        src={`assets/img/ci/my-point-stamp/free/stamp-p2-${i + 1}.png`}
                      ></img>
                    </>
                  )}
                </div>

              );
            })}
            {isDogCompleted() && (
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 10
              }}>
                <img
                  src={all}
                  alt="completed"
                  style={{
                    maxWidth: '75%',
                    maxHeight: '100%',
                    objectFit: 'contain'
                  }}
                />
              </div>
            )}
          </div>
        ) : (
          <div className="bPackCard cat" style={{
            position: 'relative',
            backgroundColor: isCatCompleted() ? '#F8F9FA' : '',
            opacity: isCatCompleted() ? 0.7 : 1
          }}>
            {[...Array(6)].map((item, i) => {
              return (
                <div
                  className={`bItemCard ${(_stampCountList[0]?.totalStamp || 0) > i ? " done " : ""
                    }`}
                >
                  {(_stampCountList[0]?.totalStamp || 0) > i ? (
                    <>
                      <i>{i + 1}</i>
                      <img
                        className="bPic done"
                        src={`assets/img/ci/my-point-stamp/used/stamp-cat-p2-${i + 1}.png`}
                      ></img>
                    </>
                  ) : (
                    <>
                      <i>{i + 1}</i>
                      <img
                        className="bPic free"
                        src={`assets/img/ci/my-point-stamp/free/stamp-cat-p2-${i + 1}.png`}
                      ></img>
                    </>
                  )}
                </div>

              );
            })}
            {isCatCompleted() && (
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 10
              }}>
                <img
                  src={allGreen}
                  alt="completed"
                  style={{
                    maxWidth: '75%',
                    maxHeight: '100%',
                    objectFit: 'contain'
                  }}
                />
              </div>
            )}
          </div>
        )}
        {/* <div className="bControlStamp">
          {currentIndex > 0 && (
            <button
              className="btnControl back"
              onClick={() => {
                const tmpValue = currentIndex - 1;
                onBack(tmpValue);
              }}
            >
              <img src={left} alt="left" />
              <span className="mt-[3px]">หน้าก่อน</span>
            </button>
          )}
          {currentIndex < _stampCountList.length - 1 && (
            <button
              className="btnControl next"
              onClick={() => {
                const tmpValue = currentIndex + 1;
                onNext(tmpValue);
              }}
            >
              <span className="mt-[3px]">หน้าถัดไป</span>
              <img src={right} alt="right" />
            </button>
          )}
        </div> */}

        <div className="pt-[10px] mt-[25px]" style={{ borderTop: '1px solid #E5E5E5' }}>
          <div className="bStampBook" style={{ backgroundColor: (reward.dog || 0) === 3 ? '#F2F2F2' : '' }}>
            <div
              className="bItemCard"
            >
              <div className="bStamp">
                <img
                  className="bPic w-[45px]"
                  src={`assets/img/ci/my-point-stamp/used/stamp-p2-1.png`}
                ></img>
              </div>
              <div className="bText">
                <h4>สมุดแสตมป์แลกของรางวัลฟรี</h4>
                <p>คุณสะสมสมุดแสตมป์เล่มที่ {reward.dog || 0}/3</p>
                {reward.dogHistory && reward.dogHistory.length > 0 && (
                  <p style={{ fontSize: '14px', color: '#666', margin: '2px 0' }}>
                    {reward.dogHistory.map((branch, index) => (
                      <span key={index}>
                        สาขา {branch.name}{index < reward.dogHistory.length - 1 ? ', ' : ''}
                      </span>
                    ))}
                  </p>
                )}
              </div>

              {/* <button className="bBtn" onClick={() => navigate("/redeem-gift-member")}>แลกรางวัล</button> */}
            </div>
          </div>
          {reward.cat > 0 && (
            <div className="bStampBook" style={{ backgroundColor: (reward.cat || 0) === 3 ? '#F2F2F2' : '' }}>
              <div
                className="bItemCard"

              >
                <div className="bStamp">
                  <img
                    className="bPic w-[45px]"
                    src={`assets/img/ci/my-point-stamp/used/stamp-cat.png`}
                  ></img>
                </div>
                <div className="bText">
                  <h4>สมุดแสตมป์แลกของรางวัลฟรี</h4>
                  <p>คุณสะสมสมุดแสตมป์เล่มที่ {reward.cat || 0}/3</p>
                  {reward.catHistory && reward.catHistory.length > 0 && (
                    <p style={{ fontSize: '14px', color: '#666', margin: '2px 0' }}>
                      {reward.catHistory.map((branch, index) => (
                        <span key={index}>
                          สาขา {branch.name}{index < reward.catHistory.length - 1 ? ', ' : ''}
                        </span>
                      ))}
                    </p>
                  )}
                </div>
                {/* <button className="bBtn" onClick={() => navigate("/redeem-gift-member")}>แลกรางวัล</button> */}
              </div>
            </div>
          )}
        </div>

      </div>
    </div>
  );
}
